import {
  Box,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { SimpleForm, useDataProvider } from "react-admin";
import { SchoolIdSelected } from "utils/tools";
import AssignmentSummaryBox from "./AssignmentSummaryBox";
import CustomDatePickerInput from "./CustomDatePickerInput";

const useStyles = makeStyles({
  waveTitle: {
    fontSize: "18px",
    marginBottom: 10,
  },
  formContainer: {
    "& .MuiCardContent-root": {
      paddingLeft: 0,
    },
  },
  waveWrapper: {
    padding: "6px 16px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: 10,
    marginBottom: 20,
  },
});

const DashboardOperation = () => {
  const [busSchedulePlans, setBusSchedulePlans] = useState<IBusSchedulePlans[]>(
    []
  );
  const [busScheduleIds, setBusScheduleIds] = useState<number[]>([]);
  const [busSchedulePlansWithWaveName, setBusSchedulePlansWithWaveName] =
    useState<any>([]);
  const [value, setValue] = useState<string>(moment().format("yyyy-MM-DD"));

  const provider = useDataProvider();
  const classes = useStyles();
  const schoolId = SchoolIdSelected();

  useEffect(() => {
    if (schoolId) {
      provider
        .getList("busSchedulePlans", {
          filter: { SchoolId: Number(schoolId) },
          pagination: {
            page: 1,
            perPage: 1000,
          },
          sort: {
            field: "Id",
            order: "ASC",
          },
        })
        .then((result) => {
          setBusSchedulePlans(result.data as IBusSchedulePlans[]);
          setBusScheduleIds([]);
          setBusSchedulePlansWithWaveName([]);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  useEffect(() => {
    if (busSchedulePlans.length > 0) {
      let tempBusScheduleIds: number[] = [];
      busSchedulePlans.forEach((busSchedulePlan: IBusSchedulePlans) =>
        tempBusScheduleIds.push(busSchedulePlan.busScheduleId)
      );

      setBusScheduleIds((value) => [...value, ...tempBusScheduleIds]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlans]);

  useEffect(() => {
    if (busScheduleIds.length === 0) {
      setBusSchedulePlansWithWaveName([]);
      return;
    }

    if (busScheduleIds.length === busSchedulePlans.length) {
      provider
        .getMany("busSchedules", { ids: busScheduleIds })
        .then(({ data }) => {
          busSchedulePlans.forEach((busSchedulePlan: any) => {
            data.forEach((busSchedule) => {
              if (busSchedulePlan.busScheduleId === busSchedule.id) {
                busSchedulePlan.waveName = busSchedule.name;
              }
            });
          });

          setBusSchedulePlansWithWaveName(busSchedulePlans);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busScheduleIds]);

  return (
    <CardContent>
      <Typography variant="h6" gutterBottom>
        Total No. Of Assignments
      </Typography>

      <SimpleForm toolbar={null} className={classes.formContainer}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={2}>
            <CustomDatePickerInput
              label="Date"
              value={value}
              setValue={setValue}
            />
          </Grid>
        </SanitizedGrid>
      </SimpleForm>

      {busSchedulePlansWithWaveName.length > 0 ? (
        <>
          {busSchedulePlansWithWaveName.map((busSchedulePlan: any) => {
            return (
              <Box className={classes.waveWrapper}>
                <Typography
                  className={classes.waveTitle}
                  variant="h6"
                  align="left"
                >
                  {busSchedulePlan.waveName}
                </Typography>

                <AssignmentSummaryBox
                  busSchedulePlanId={busSchedulePlan.id}
                  date={value}
                />
              </Box>
            );
          })}
        </>
      ) : (
        <Typography className={classes.waveTitle} variant="h6" align="left">
          This School doesn't have any active wave
        </Typography>
      )}
    </CardContent>
  );
};

export default DashboardOperation;
